import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-utms-report',
  templateUrl: './utms-report.component.html',
  styleUrls: ['./utms-report.component.scss']
})
export class UtmsReportComponent implements OnInit {

  displayedColumns: string[] = ['utm_camp', 'count'];
  columnsDisplayName = {
    utm_camp: 'Campanha',
    count: 'Quantidade'
  }
  public datasource: MatTableDataSource<any> = new MatTableDataSource<any>();
  form: FormGroup;
  submiting: boolean = false;

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    fb: FormBuilder
  ) {
    this.form = fb.group({
      dateStart: [null, Validators.required],
      dateEnd: [null, Validators.required]
    })
  }

  ngOnInit(): void {
    this.datasource.data = null
    const subject = new Subject<any>();
    subject.subscribe(({ trigger }: any) => {
      this.submiting = trigger == 'pre';
    })
    this.http.setLoadingIndicator(subject, 'analytics:utm')

    this.form.valueChanges
      .subscribe(() => {
        if (this.form.valid)
          this.submit();
      })
  }

  getUTMCampaigns(data: any) {
    this.http.list('analytics:utm', data)
      .subscribe({
        next: (response: any) => {
          this.datasource.data = response;
        },
        error: (err: any) => {
          this.errorReport.showMessage(err)
        }
      })
  }

  submit() {
    if (this.form.valid) {
      const data = this.form.getRawValue();
      this.getUTMCampaigns(data);
    }
  }

}
